import {
    PeriodType,
    ScorecardBoxDto,
    ScorecardDataDto,
} from '../scorecard/scorecard.model';
import { createAction } from '../store.model';
import { User } from '../user/user.model';

import { HistoryPositionNavigate } from './general/history-position-navigate.model';

export enum ActionType {
    SCORECARD_CARD__RELOAD = 'SCORECARD_CARD__RELOAD',
    SCORECARD_CARD__RELOAD_RESULT = 'SCORECARD_CARD__RELOAD_RESULT',
    SCORECARD_CARD__RELOAD_CANCEL = 'SCORECARD_CARD__RELOAD_CANCEL',
    SCORECARD_CARD__LIST_DATA = 'SCORECARD_CARD__LIST_DATA',
    SCORECARD_CARD__LIST_DATA_RESULT = 'SCORECARD_CARD__LIST_DATA_RESULT',
    SCORECARD_CARD__SELECT_PERIOD_TYPE = 'SCORECARD_CARD__SELECT_PERIOD_TYPE',
    SCORECARD_CARD__LIST_DATA_CANCEL = 'SCORECARD_CARD__LIST_DATA_CANCEL',
    SCORECARD_CARD__NAVIGATE_HISTORY = 'SCORECARD_CARD__NAVIGATE_HISTORY',
    SCORECARD_CARD__RESET = 'SCORECARD_CARD__RESET',
    SCORECARD_CARD__SELECT_MENU_ITEM = 'SCORECARD_CARD__SELECT_MENU_ITEM',
    SCORECARD_CARD_ROOT__CLEAR_STATE = 'SCORECARD_CARD_ROOT__CLEAR_STATE',
}

/// ///////

export interface Reload {
    periodTypes?: PeriodType[];
    user?: User;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.SCORECARD_CARD__RELOAD,
);
export interface ReloadResult extends Reload {
    scorecardBoxes?: ScorecardBoxDto[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.SCORECARD_CARD__RELOAD_RESULT,
);

/// ///////

export interface ListData {
    scorecardIds: number[];
}

export interface ListDataResult extends ListData {
    scorecardData?: ScorecardDataDto[];
}

export const listData = createAction<ActionType, ListData>(
    ActionType.SCORECARD_CARD__LIST_DATA,
);
export const listDataResult = createAction<ActionType, ListDataResult>(
    ActionType.SCORECARD_CARD__LIST_DATA_RESULT,
);

/// ///////

export interface SelectPeriodType {
    periodType: PeriodType;
}

export const selectPeriodType = createAction<ActionType, SelectPeriodType>(
    ActionType.SCORECARD_CARD__SELECT_PERIOD_TYPE,
);

/// //////

export interface NavigateHistory {
    historyPosNav: HistoryPositionNavigate;
}

export const navigateHistory = createAction<ActionType, NavigateHistory>(
    ActionType.SCORECARD_CARD__NAVIGATE_HISTORY,
);

/// ///////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

/** TODO revise. this is temporary means of flushing tabs after auth user has changed */
export const reset = createAction<ActionType, Reset>(
    ActionType.SCORECARD_CARD__RESET,
);

/// ///////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const clearState = createAction<ActionType, RootClearStateAction>(
    ActionType.SCORECARD_CARD_ROOT__CLEAR_STATE,
);
